import Assistance from '@/view/Assistance/Assistance'

const TABLE_BREADCRUMB = {
  code: 'assistance.name',
  link: {
    name: 'assistance',
  },
}

export default [
  {
    path: '/assistance',
    name: 'assistance',
    component: Assistance,
    meta: {
      auth: 'hasRole(ROLE_ADMIN,ROLE_CORRESPONDANT,ROLE_PARTICIPANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
  },
]
